import { type Car } from '@prisma/client'
import { useState } from 'react'
import { getImgSrc } from '#app/shared/lib/misc.tsx'
import { FullScreenGallery } from '#app/shared/ui/data-display/carousel/FullScreenGallery.tsx'
import { Spacer } from '#app/shared/ui/data-display/Spacer.js'
import VehicleCertificates from './vehicleCertificate-new'

type Props = {
  id: string
  car: Car & {
    condition: string
    images: { id: string; isSignOfUse: boolean }[]
  }
  signOfUseImageIds: string[]
}

export default function Conditions({ id, car, signOfUseImageIds }: Props) {
  const [open, setOpen] = useState(false)
  return (
    <div className="rounded-b-base bg-white" id={id}>
      <Spacer size="40px" />
      <p className="ml-7 text-h4 text-neutral-900">Condición</p>

      <FullScreenGallery
        open={open}
        onClose={() => setOpen(false)}
        imagesArray={signOfUseImageIds.map((image) =>
          getImgSrc(image, 'carImage'),
        )}
        initialIndex={0}
      />

      <Spacer
        className={`
          hidden

          sm:block
        `}
        size="16px"
      />

      <Spacer size="8px" sizeMd="20px" />
      <div
        className={`
          px-4

          md:px-0
        `}
      >
        <VehicleCertificates signOfUseImageIds={signOfUseImageIds} car={car} />
      </div>
    </div>
  )
}
